/**
 * Created by Jerker Nord on 2024-02-14.
 */
import {Loner} from "../../../../Loner";
import {LonerStatics} from "../../../../LonerStatics";
import {LonerBigWildSymbol2x2} from "./LonerBigWildSymbol2x2";
import {LonerSymbolStates, WILD_2X2_NAMES, WILD_2X2_SPLIT_NAMES} from "../../../../../core/reel/ReelInterfaces";
import {gsap} from "gsap";
import {LonerWinLineContainer} from "../../../../components/LonerWinLineContainer";

export class LonerBigWildPresentationSymbol2x2 extends LonerBigWildSymbol2x2 {

    private static WIN_TEXTURES:string[] = ["wild2X2/2x2_bot", "wild2X2/wild2X2", "wild2X2/2x2_top"];
    private static WIN_CONTAINER_Y_POS_OFFSET:number[] = [60, 0, -60];
    private static BIG_SYMBOL_CONTAINER_DEFAULT_POS:PIXI.Point = new PIXI.Point(0 - (LonerStatics.symbolWidth / 2), 0 - (LonerStatics.symbolHeight / 2));

    private _currentSplitStateSprite:PIXI.Sprite;

    constructor() {
        super();
        this._bigSymbolSplitContainer.alpha = 0;
        this._currentSplitStateSprite = new PIXI.Sprite();
        this._currentSplitStateSprite.anchor.set(0.5, 0.5);
        this._bigSymbolSplitContainer.addChild(this._currentSplitStateSprite);
        this._darkOverlay.width = LonerStatics.symbolWidth * 2;
        this._darkOverlay.height = LonerStatics.symbolHeight * 2;
    }

    public getNewStateAnimation(state:LonerSymbolStates, changeSpeed:number = 0.0001, delay:number = 0, newStateAlpha:number = 1):gsap.core.Timeline {
        if(state == LonerSymbolStates.SPIN_OUT) {
            this._splitLevel = 1;
            gsap.to(this._bigSymbolSplitContainer, {duration:changeSpeed,delay:delay, alpha:0});
            this._currentStateSprite.visible = true;
        }
        return super.getNewStateAnimation(state, changeSpeed, delay, newStateAlpha);
    }

    protected setSplitContainerBasePosition():PIXI.Point {
        const position:PIXI.Point = new PIXI.Point((this._reelId * LonerStatics.symbolWidth) - (LonerStatics.symbolWidth / 2), ((this._reelPosition - 1) * LonerStatics.symbolHeight));

        if (this._reelPosition > 3){
            position.y -= (LonerStatics.symbolHeight/2);
        }
        if (this._reelPosition == 6){
            position.y -= (LonerStatics.symbolHeight/2);
        }

        return position;
    }

    public getInitialWinAnimation(winContainer:LonerWinLineContainer):gsap.core.Timeline {
        return super.getInitialWinAnimation(winContainer);
    }

    public getSplitSymbolTL():gsap.core.Timeline {
        const splitTL:gsap.core.Timeline = gsap.timeline();
        if(this.symbolName == "S" || this.bigSymbolPart == true) {
            return splitTL;
        }
        this._splitLevel *= 2;
        if(this._splitLevel == 2) {
            splitTL.add(() => {
                this._split2SymbolContainer.alpha = 0;
                this._split2SymbolContainer.visible = true;
                this._split2SymbolSprite.texture = this.getSplitSymbolStartTexture();
                this._split2SymbolAddSprite.texture = this._split2SymbolSprite.texture;
            });
            splitTL.add(() => {
                this._split2SymbolContainer.position = this.setSplitContainerBasePosition();
                this._split2SymbolContainer.scale.set(1.08, 1.08);
                this._split2SymbolContainer.alpha = 1;
            });
        } else {
            splitTL.add(() => {
                this._split4SymbolContainer.alpha = 0;
                this._split4SymbolContainer.visible = true;
                this._split4SymbolSprite.texture = this.getSplitSymbolStartTexture();
                this._split4SymbolAddSprite.texture = this._split4SymbolSprite.texture;
            });
            splitTL.add(() => {
                this._split4SymbolContainer.position = this.setSplitContainerBasePosition();
                this._split4SymbolContainer.scale.set(1.08, 1.08);
                this._split4SymbolContainer.alpha = 1;
            });
        }

        if(this._splitLevel == 2) {
            splitTL.add(this.getNewStateAnimation(LonerSymbolStates.SPLIT2));
            splitTL.add(() => {
                this._bigSymbolSplitContainer.position = this._bigSymContainer.position;
                this._bigSymbolSplitContainer.alpha = 1;
                this._currentSplitStateSprite.texture = this._currentStateSprite.texture.clone();
                this._currentStateSprite.visible = false;
                this._bigSymContainer.position.y -= LonerStatics.symbolHeight/4;
                if(this._reelPosition == 3) {
                    this._bigSymbolSplitContainer.position.y = LonerBigWildPresentationSymbol2x2.BIG_SYMBOL_CONTAINER_DEFAULT_POS.y + (LonerStatics.symbolHeight / 2);
                }
                if(this._reelPosition == 6) {
                    this._bigSymbolSplitContainer.position.y = LonerBigWildPresentationSymbol2x2.BIG_SYMBOL_CONTAINER_DEFAULT_POS.y - (LonerStatics.symbolHeight / 2);
                }
            })
        } else {
            splitTL.add(this.getNewStateAnimation(LonerSymbolStates.SPLIT4));
            splitTL.add(() => {
                this._bigSymbolSplitContainer.position = this._bigSymContainer.position;
                this._bigSymbolSplitContainer.alpha = 1;
                this._currentSplitStateSprite.texture = this._currentStateSprite.texture.clone();
                this._currentStateSprite.visible = false;
                this._bigSymContainer.position.y -= LonerStatics.symbolHeight/4;
                if(this._reelPosition == 3) {
                    this._bigSymbolSplitContainer.position.y = LonerBigWildPresentationSymbol2x2.BIG_SYMBOL_CONTAINER_DEFAULT_POS.y + (LonerStatics.symbolHeight / 2);
                }
                if(this._reelPosition == 6) {
                    this._bigSymbolSplitContainer.position.y = LonerBigWildPresentationSymbol2x2.BIG_SYMBOL_CONTAINER_DEFAULT_POS.y - (LonerStatics.symbolHeight / 2);
                }
            })
        }

        if(this._splitLevel == 2) {
            splitTL.add(() => {
                this._split2SymbolSprite.texture = this.getSplitSymbolSplitTexture();
                this._split2SymbolAddSprite.texture = this.getSplitSymbolSplitTexture();
            })
            splitTL.add([
                gsap.to(this._split2SymbolContainer.scale, {duration : 0.16, x : 1, y : 1}),
                gsap.to(this._split2SymbolAddSprite, {duration : 0.33, alpha : 0}),
                gsap.to(this._split2SymbolSprite, {duration : 0.33, alpha : 0})
            ]);
            splitTL.add(()=>{
                this._split2SymbolContainer.visible = false;
                this._split2SymbolSprite.alpha = 1;
                this._split2SymbolAddSprite.alpha = 1;
            })
        } else {
            splitTL.add(() => {
                this._split4SymbolSprite.texture = this.getSplitSymbolSplitTexture();
                this._split4SymbolAddSprite.texture = this.getSplitSymbolSplitTexture();
            })
            splitTL.add([
                gsap.to(this._split4SymbolContainer.scale, {duration : 0.16, x : 1, y : 1}),
                gsap.to(this._split4SymbolAddSprite, {duration : 0.33, alpha : 0}),
                gsap.to(this._split4SymbolSprite, {duration : 0.33, alpha : 0})
            ]);
            splitTL.add(()=>{
                this._split4SymbolContainer.visible = false;
                this._split4SymbolSprite.alpha = 1;
                this._split4SymbolAddSprite.alpha = 1;
            })
        }

        return splitTL;
    }

    protected getSplitSymbolSplitTexture():PIXI.Texture {
        if(this._reelPosition == 3) {
            return Loner.assetLoader.getTextures(this.symbolName + "/" + WILD_2X2_SPLIT_NAMES.topPosition + this._splitLevel)[0];
        } else if(this._reelPosition == 6) {
            return Loner.assetLoader.getTextures(this.symbolName + "/" + WILD_2X2_SPLIT_NAMES.bottomPosition + this._splitLevel)[0];
        } else {
            return Loner.assetLoader.getTextures(this.symbolName + "/" + WILD_2X2_SPLIT_NAMES.fullPosition + this._splitLevel)[0];
        }
    }

    protected getSplitSymbolStartTexture():PIXI.Texture {
        if(this._splitLevel == 2) {
            //Splitlevel 0 -> 2. Start with no split
            if(this._reelPosition == 3) {
                return Loner.assetLoader.getTextures(this.symbolName + "/" + WILD_2X2_NAMES.topPosition)[0];
            } else if(this._reelPosition == 6) {
                return Loner.assetLoader.getTextures(this.symbolName + "/" + WILD_2X2_NAMES.bottomPosition)[0];
            } else {
                return Loner.assetLoader.getTextures(this.symbolName + "/" + WILD_2X2_NAMES.fullPosition)[0];
            }
        } else {
            ////Splitlevel 2 -> 4. Start with two split
            if(this._reelPosition == 3) {
                return Loner.assetLoader.getTextures(this.symbolName + "/" + WILD_2X2_SPLIT_NAMES.topPosition + 2)[0];
            } else if(this._reelPosition == 6) {
                return Loner.assetLoader.getTextures(this.symbolName + "/" + WILD_2X2_SPLIT_NAMES.bottomPosition + 2)[0];
            } else {
                return Loner.assetLoader.getTextures(this.symbolName + "/" + WILD_2X2_SPLIT_NAMES.fullPosition + 2)[0];
            }
        }
    }

    protected setWinTextures():void {
        let winTexture:string;
        let winAddTexture:string;

        if(this.reelPosition == 3) {
            if(this._splitLevel > 1) {
                winTexture = LonerBigWildPresentationSymbol2x2.WIN_TEXTURES[0] + "_Split_" + this._splitLevel + "_win";
                winAddTexture = LonerBigWildPresentationSymbol2x2.WIN_TEXTURES[0] + "_Split_" + this._splitLevel + "_win_add";
            } else {
                winTexture = LonerBigWildPresentationSymbol2x2.WIN_TEXTURES[0] + "_win";
                winAddTexture = LonerBigWildPresentationSymbol2x2.WIN_TEXTURES[0] + "_win_add";
            }
        } else if(this.reelPosition == 6) {
            if(this._splitLevel > 1) {
                winTexture = LonerBigWildPresentationSymbol2x2.WIN_TEXTURES[2] + "_Split_" + this._splitLevel + "_win";
                winAddTexture = LonerBigWildPresentationSymbol2x2.WIN_TEXTURES[2] + "_Split_" + this._splitLevel + "_win_add";
            } else {
                winTexture = LonerBigWildPresentationSymbol2x2.WIN_TEXTURES[2] + "_win";
                winAddTexture = LonerBigWildPresentationSymbol2x2.WIN_TEXTURES[2] + "_win_add";
            }
        } else {
            if(this._splitLevel > 1) {
                winTexture = LonerBigWildPresentationSymbol2x2.WIN_TEXTURES[1] + "_Split_" + this._splitLevel + "_win";
                winAddTexture = LonerBigWildPresentationSymbol2x2.WIN_TEXTURES[1] + "_Split_" + this._splitLevel + "_win_add";
            } else {
                winTexture = LonerBigWildPresentationSymbol2x2.WIN_TEXTURES[1] + "_win";
                winAddTexture = LonerBigWildPresentationSymbol2x2.WIN_TEXTURES[1] + "_win_add";
            }
        }
        this._winStateNormalSprite.texture = Loner.assetLoader.getTextures(winTexture)[0];
        this._winStateAddSprite.texture = Loner.assetLoader.getTextures(winAddTexture)[0];
    }

    protected setWinContainerPosition():void {
        this._winStateContainer.position.x -= (LonerStatics.symbolWidth / 2);
        this._winStateContainer.position.y -= (LonerStatics.symbolHeight / 2);
        if(this.reelPosition == 3) {
            this._winStateContainer.position.y += LonerBigWildPresentationSymbol2x2.WIN_CONTAINER_Y_POS_OFFSET[0];
            this._darkOverlay.height = LonerStatics.symbolHeight;
        } else if(this.reelPosition == 6) {
            this._winStateContainer.position.y += LonerBigWildPresentationSymbol2x2.WIN_CONTAINER_Y_POS_OFFSET[2];
            this._darkOverlay.height = LonerStatics.symbolHeight;
        } else {
            this._winStateContainer.position.y += LonerBigWildPresentationSymbol2x2.WIN_CONTAINER_Y_POS_OFFSET[1];
            this._darkOverlay.height = LonerStatics.symbolHeight * 2;
        }
    }

    public reset():void {
        this._bigSymContainer.position = LonerBigWildPresentationSymbol2x2.BIG_SYMBOL_CONTAINER_DEFAULT_POS;
        super.reset();
    }
}